<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/orders/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/orders/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Return Orders</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-6">
        </div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <button type="button" (click)="costEstimate()" *ngIf="tabClicked == 'shippingOptions'" class="btn btn-orange ml-1">Next</button>
          <button type="submit" (click)="Submit()" *ngIf="tabClicked == 'shippingOptions'" class="btn btn-orange ml-1" [disabled]="!order?.orderNumber">Submit</button>
        </div>
      </div>
    </div>
  </div>

  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-2 review">Recipient Information</h2>
          <div class="row mt-3">
            <div class="col-4">
              <label><b>Order# :</b><span class="ml-1"></span>{{order.orderNumber}}</label><br>
              <label><b>Create Date :</b><span class="ml-1"></span>{{order.orderedDate}}</label><br>
              <label><b>Status : </b>{{order.orderStatus | replaceStatus}}</label><br>
              <label><b>Connection Name : </b>{{order.connectionName}}</label><br>
            </div>
            <div class="col-lg-4">
              <h2 class="text-black mb-2 review">Sender Details</h2>
              <label><b>Sender Name :</b><span class="ml-1">{{order.senderName}}</span></label><br>
              <label><b>Sender Address :</b><span class="ml-1">{{order.senderAddressText}}</span></label>
            </div>
            <div class="col-lg-4">
              <h2 class="text-black mb-2 review">Receiver Details</h2>
              <label class="text-black"><b>Receiver Name :</b><span class="ml-1">{{order.receiverName}}</span></label><br>
              <label><b>Receiver Address :</b><span class="ml-1">{{order.receiverAddressText}}</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">

      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a class="list-inline-item" (click)=" tabChange('selectedProducts');" [ngClass]="{'active': tabClicked === 'selectedProducts'}">Selected Products <div class="dot bg-danger ml-2" *ngIf="quantityError || selectReasonError"></div></a></li>
          <li class="list-inline-item"><a class="nav-link warehouses" (click)=" tabChange('shippingOptions');" [ngClass]="{'active': tabClicked === 'shippingOptions'}">Shipping Options</a></li>
        </ul>
        <div class="inner-box">
          <div class="row mt-3" *ngIf="tabClicked == 'selectedProducts'">
            <div class="col-12">
              <div class="table-3">
                <table class="table  packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th class="pl-0">Product Name</th>
                    <th>SKU</th>
                    <th td style="width:396px;">Quantity</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let ol of orderLines">
                    <td>{{ol.productName}}</td>
                    <td class="text-black mb-3">{{ol.sku}}</td>
                    <td td style="width:396px;"><input type="text" id="quantity" [(ngModel)]="ol.quantity" [ngModelOptions]="{standalone: true}" class="form-control" required [disabled]="ol.previousQuantity==1"></td>
                    <td>
                      <a (click)="removeProduct(ol)">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg> Delete
                      </a>
                    </td>
                  </tr>
                  <tr [hidden]="!quantityError" > <td colspan="2"> </td><td style="width:396px;" class="invalid-feedback-td  shift-invalid-login"> {{quantityError}}</td><td> </td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-4 mt-3">
              <label>Select Reason</label>
              <ng-select [ngClass]="{'service-error':selectReasonError}" (change)="checkError()"  placeholder="Select Reason"  [(ngModel)]="order.returnReason" [ngModelOptions]="{standalone: true}" required [items]="reasonsList" bindLabel="config" bindValue="config">
              </ng-select>
              <div id="selectReasonError" class="invalid-feedback d-block" [hidden]="!selectReasonError">{{selectReasonError}}</div>
            </div>
          </div>

          <div class="mt-4" *ngIf="tabClicked == 'shippingOptions'">
            <div class="row mt-3">
              <div class="col">
                <div class="inner-box">
                  <h2 class="text-black mb-3">Shipping Options</h2>
                  <div class="mt-3">
                    <div class="table-3" style="overflow-x:auto;">
                      <table class="table packing-table packing-table-2">
                        <thead class="thead-light">
                        <tr>
                          <th>Select</th>
                          <th></th>
                          <th>Courier Partner</th>
                          <th>Courier Mode</th>
                          <th>Price</th>
                          <th>Pickup Available</th>
                          <th>Estimated Delivery(in Days)</th>
                        </tr>
                        </thead>
                        <tbody *ngFor="let co of costEstimation; let i=index;">
                        <tr *ngFor="let c of co.costEstimates; let j=index;">
                          <td>
                            <div class="form-radio">
                              <input type="radio" id="cost+{{i}}+{{j}}" (change)="selectCost(c)" required name="costEstimate">
                              <label for="cost+{{i}}+{{j}}"></label>
                            </div>
                          </td>
                          <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                          <td>
                            {{(co.carrierCode == 'SD' ? 'Shift' :
                            (co.carrierCode == 'DL' ? 'Delhivery' :
                            (co.carrierCode == 'GT' ? 'Gati' :
                            (co.carrierCode == 'DZ' ? 'Dotzot' :
                            (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                            (co.carrierCode == 'SF' ? 'Shadow Fax' :
                            (co.carrierCode == 'XB' ? 'Xpressbees' :
                            (co.carrierCode == 'KE' ? 'Kerry' :
                            (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode)))))))))}}
                            <div *ngIf="c.shippingPreference != ''" style="display: inline-flex;" class="ml-2">{{c.shippingPreference}}</div>
                          </td>
                          <td>
                            <div *ngIf="c.deliveryMode && c.serviceType !== null">
                              {{c.deliveryMode + '/' + c.serviceType | replaceStatus}}
                            </div>
                            <div *ngIf="c.serviceType == null">{{c.deliveryMode | replaceStatus}}</div>
                            <div *ngIf="c.deliveryMode == null">{{c.serviceType | replaceStatus}}</div>
                          </td>
                          <td>{{c.totalAmount | currency:'INR'}}</td>
                          <td>{{"Yes"}}</td>
                          <td>{{"1 day"}}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr *ngIf="costEstimation?.length ===0 || !costEstimation?.length">
                          <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                        </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

